<template lang="pug">
.compartilhamento-dados-listagem.w-100
    el-table.w-100(
        height='calc(100vh - 315px)',
        :data='tableData',
        @sort-change='sortChangeRequest'
    )
        el-table-column(
            prop='dataCadastroFormatado',
            :label='$t("mensagens.relatorioCompartilhamentoDeDados.labels.data")',
            sortable='custom',
            :min-width='10'
        )
        el-table-column(
            prop='horaCadastroFormatado',
            :label='$t("mensagens.relatorioCompartilhamentoDeDados.labels.hora")',
            :min-width='10'
        )
        el-table-column(
            prop='nomeUsuario',
            :label='$t("mensagens.relatorioCompartilhamentoDeDados.labels.usuario")',
            sortable='custom',
            :min-width='25'
        )
        el-table-column(
            prop='nomeEmpresa',
            :label='$t("mensagens.relatorioCompartilhamentoDeDados.labels.empresa")',
            sortable='custom',
            :min-width='20'
        )
        el-table-column(
            prop='situacaoNome',
            :label='$t("mensagens.relatorioCompartilhamentoDeDados.labels.situacao")',
            sortable='custom',
            :min-width='15'
        )
            .template(slot-scope='scope')
                div(
                    :class='["situacao", scope.row.situacaoNome === "Em processamento" ? "emProcessamento" : scope.row.situacaoNome === "Falha no processamento" ? "falhaProcessamento" : "processado"]'
                ) {{ traduzirSituacao(scope.row.situacaoNome) }}
        el-table-column(
            :label='$t("mensagens.relatorioCompartilhamentoDeDados.labels.arquivosGerados")',
            align='center',
            :min-width='20'
        )
            .template(slot-scope='scope')
                div(
                    style='display: inline-flex',
                    v-if='scope.row.situacaoNome === "Processado"'
                )
                    .link
                        i.mdi.mdi-file-excel-outline(
                            @click='downloadResultado(scope.row.id)'
                        ) &nbsp {{ $t('mensagens.relatorioCompartilhamentoDeDados.labels.relatorio') }}
                    .link
                        i.mdi.mdi-file-download-outline(
                            @click='downloadShape(scope.row.id)'
                        ) &nbsp Shapefile
</template>

<script>
import CompartilhamentoDadosService from '@/services/CompartilhamentoDadosService';
import UtilsService from '@/services/UtilsService';

export default {
    name: 'CompartilhamentoDadosListagem',
    props: {
        tableData: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            VUE_APP_HTTP_PATH: ''
        };
    },

    created() {
        this.VUE_APP_HTTP_PATH = process.env.VUE_APP_HTTP_PATH;
    },

    methods: {
        traduzirSituacao(situacao) {
            const normalizedSituacao = situacao
                .toUpperCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/ /g, '-');

            return this.$t(
                `mensagens.relatorioCompartilhamentoDeDados.${normalizedSituacao}`
            );
        },

        sortChangeRequest(column) {
            let prop = column.prop;
            if (prop.includes('.')) {
                prop = prop.split('.')[1];
            }

            if (prop === 'dataCadastroFormatado') {
                prop = 'dataCadastro';
            }

            if (prop === 'situacaoNome') {
                prop = 'situacaoCompartilhamentoDados';
            }

            let params = {
                order: null,
                column: prop
            };

            if (column.order === 'ascending') {
                params.order = 'ASC';
            } else if (column.order === 'descending') {
                params.order = 'DESC';
            }

            this.$emit('handleSort', params);
        },

        downloadResultado(id) {
            CompartilhamentoDadosService.downloadResultado(id)
                .then(() => {
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.relatorioCompartilhamentoDeDados.notificacoes.downlaodRealizadoComSucesso'
                        )
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.relatorioCompartilhamentoDeDados.notificacoes.erroAoRealizarDownload'
                        )
                    });
                });
        },

        downloadShape(id) {
            UtilsService.baixarArquivo(`/compartilhamento-dados/shape/${id}`);
        }
    }
};
</script>

<style lang="scss">
.compartilhamento-dados-listagem {
    .el-table {
        border-radius: 5px;

        .cell {
            word-break: break-word !important;
        }

        .action-button {
            cursor: pointer;
        }
    }

    .situacao {
        border-radius: 50px;
        text-align: center;
        color: var(--white);
        max-width: 170px;
    }

    .processado {
        background-color: var(--primary);
    }

    .falhaProcessamento {
        background-color: var(--danger);
    }

    .emProcessamento {
        background-color: var(--warning);
    }

    .buttonCard {
        background: var(--white);
        height: 60px;
        top: -15px;
        position: relative;
        padding: 10px;
    }

    .link {
        margin-left: 20px;
        cursor: pointer;
        i {
            display: inline-flex;
            vertical-align: bottom;
            font-style: normal;
            font-size: 13px;
            color: #19194b;
        }
    }
}
</style>
